import { createContext } from 'react';

import { ModuleContextDef } from './types';

export const ModuleContext = createContext<ModuleContextDef | null>(null);
